// extracted by mini-css-extract-plugin
export default {"globalLoadingModal":"GlobalLoadingModal_globalLoadingModal__tHl49"};